import React from "react";
import PropTypes from "prop-types";
import $ from "jquery";

class SignInAndSearch extends React.Component {
    static propTypes = {
        isSignInOn: PropTypes.bool,
        isSearchOn: PropTypes.bool,
        isMobile: PropTypes.bool
    };

    static defaultProps = {
        isSignInOn: true,
        isSearchOn: true,
        isMobile: false
    };

    state = {
        for: "",
        open: false
    };

    _searchButton = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if(this.state.open){
            if(this.state.for.trim()) {
                // Do search
                window.location = "/search?for=" + this.state.for;
            }
        } else {
            this.setState({open: true});
            if($(window).width() >= 1000) {
                setTimeout(function(){
                    $("#siteSearchInputDesktop").select();
                }, 500);
            } else {
                setTimeout(function(){
                    $("#siteSearchInputMobile").select();
                }, 500);
            }
        }
    }
    _closeButton = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.setState({open: false});
    }
    _handleChange = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const updates = Object.assign({}, this.state);

        updates[event.target.name] = event.target.value;

        this.setState(updates);
    } // close _handleChange

    render() {
        const searchId = this.props.isMobile ? "siteSearchInputMobile" : "siteSearchInputDesktop";

        return (
            <React.Fragment>
                {this.props.isSignInOn && <div className={(this.state.open ? "SignIn open" : "SignIn")}>
                    <a href="/sign-in" className="text-primary">
                        <i className="far fa-sign-in icon-btn text-with-space" aria-hidden="true"/>
                        Sign In
                    </a>
                    <span className="text-with-space">or</span>
                    <a href="/register" className="text-primary">Register</a>
                </div>}
                {this.props.isSearchOn && <div className={(this.state.open ? "SearchBar open" : "SearchBar")}>
                    <form className={(this.state.open ? "open" : "")} onSubmit={this._searchButton }>
                        <input id={searchId} type="text" className="search-input" name="for" value={this.state.for } onChange={ this._handleChange } placeholder="Search..." />
                    </form>
                    <button className="icon-btn close-btn" title="Open Search" onClick={ this._closeButton }>
                        <i className="far fa-times" aria-hidden="true"/>
                    </button>
                    <button className="icon-btn search-btn" title="Close Search" onClick={ this._searchButton }>
                        <i className="far fa-search" aria-hidden="true"/>
                    </button>
                </div>}
            </React.Fragment>
        );
    } // close render
} // close SignInAndSearch

export default SignInAndSearch;
